import { get, post, patch } from "../../config/api";

class FoodMakingService {       

    static async getRestaurantData(restaurantId) {
        const url = `/v3/dashboard/restaurant/${restaurantId}`;
        return await get({ url });
    }

    static async getMenuData(restaurantId) {
        const url = `/v3/dashboard/restaurant/${restaurantId}/menu`;
        return await get({ url });
    }

    static async changeRestaurantServingStatus(restaurantId, restaurantStatusPayload) {
        const url = `/v3/dashboard/restaurant/${restaurantId}/status`;
        return await post({ url, data: restaurantStatusPayload });
    }

    static async getNotificationsStatus(restaurantId) {
        const url = `/v1/dashboard/restaurant/${restaurantId}/notificationStatus`;
        return await get({ url });
    }

    static async updateNotificationsStatus(restaurantId, data) {
        const url = `/v1/dashboard/restaurant/${restaurantId}/notificationStatus`;
        return await patch({ url, data });
    }

}

export default FoodMakingService;